import React, { useState } from "react";
import { Link } from "react-router-dom";

import logo from "../../assets/landing/vendstash-nav-logo.svg";

const LINKS = [
  { href: "#how-it-works", label: "How it works" },
  // { href: "#security", label: "Security" },
  { href: "#roles", label: "For buyers & sellers" },
  { href: "#faq", label: "FAQ" },
];

const Navbar: React.FC = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className='navbar'>
      <div className='navbar__inner'>
        <a aria-label='VendStash home' className='navbar__logo' href='#top'>
          <img alt='VendStash' width={112} height={23} src={logo} />
        </a>
        <button
          aria-controls='primary-navigation'
          aria-expanded={open}
          aria-label={open ? "Close menu" : "Open menu"}
          className='navbar__menu'
          type='button'
          onClick={() => setOpen((v) => !v)}>
          <span />
          <span />
          <span />
        </button>
        <nav
          aria-label='Primary navigation'
          className='navbar__nav'
          data-open={open}
          id='primary-navigation'>
          {LINKS.map((l) => (
            <a href={l.href} key={l.href} onClick={() => setOpen(false)}>
              {l.label}
            </a>
          ))}
          <Link
            className='button button--navy navbar__cta'
            to='/signin'
            onClick={() => setOpen(false)}>
            Login
          </Link>
          <Link
            className='button button--lime navbar__cta'
            to='/signup'
            onClick={() => setOpen(false)}>
            Create an account
          </Link>
        </nav>
      </div>
    </header>
  );
};

export default Navbar;
